<div class="bloco-card bloco-acao">

    <span class="bloco-icone">
      <mat-icon aria-hidden="true">search</mat-icon>
    </span>
    <div class="bloco-textos">
      <h3 class="bloco-title">Pesquisa sob encomenda</h3>
      <p class="bloco-desc">Peça para nossa equipe pesquisar uma obra específica para você</p>
    </div>

  <button class="btn-acao" (click)="abrirModal()" type="button">
    Solicitar pesquisa
  </button>
</div>


@if (showModal) {
  <app-modal-solicitar-nova-obra
    (close)="fecharModal()"
    (loading)="onModalLoading($event)"
  ></app-modal-solicitar-nova-obra>
}